<template lang="pug">
.explore(:class="{ removeMinHeight: showDetail }", @mousemove="getMousePos")
  Tooltip(
    :show="showTooltip",
    :subtitle="$t(`explore.sights.${selectedSight.name}.name_en`)",
    :title="$t(`explore.sights.${selectedSight.name}.name`)",
    :media="selectedSight.media",
    :desc="$t(`explore.sights.${selectedSight.name}.desc`)",
    :class="{ show: true }",
    @clickMedia="clickMedia",
    @closeTooltip="showTooltip = false",
    ref="tooltip"
  )
    // @overTooltip="showTooltip = true",
    // @leaveTooltip="showTooltip = false"
  transition(name="fade")
    ExploreDetail(
      v-if="showDetail",
      :media="selectedSight.media",
      :mediaType="sightMediaType"
    )
  .explore-bg(
    :style="{ transform: `translate(${mousePos.x / 15}px,${mousePos.y / 15}px)` }"
  )
    .bg-text.bg-text-1
      .animate__animated.animate__fadeInLeft TAIPEI
    .bg-text.bg-text-2
      .animate__animated.animate__fadeInRight TAIPEI
  .container-fluid.h-100
    .row.h-100
      // img(:src="pp" style="position: fixed; top:0;left:0; width:300px")
      .col-12.col-md-4.explore-intro
        .explore-content.pl-3.pb-3
          h1.explore-title {{ $t(`explore.title`) }}
          span.explore-text(v-html="$t(`explore.intro`)")
      .col-12.col-md-8.p-0.d-flex.align-items-center.justify-content-center(
        :style="{ transform: `scale(1.02) translate(${mousePos.x / 35}px,${mousePos.y / 35 - 10}px)` }"
      )
        .explore-map
          .explore-map-item(
            v-for="(sight, index) in sights",
            :key="index",
            :style="{ left: `calc(${sight.position.left}% + ${sight.panX || 0}vw)`, bottom: `${sight.position.bottom}%`, width: `${sight.width}%`, maxWidth: `${sight.maxWidth}px` }",
            :data-sight-name="sight.name",
            @click="clickSight"
          )
            img.sight-img(
              :src="require(`@/assets/images/explore_${sight.name}.png`)"
            )
            img.magnifier(
              :src="require(`@/assets/images/explore_magnifier.png`)"
            )
            .sight-name(
              v-if="$i18n.locale == 'zh'",
              :data-sight-name="sight.name"
            ) {{ sight.name_zh }}
            .sight-name(v-else, :data-sight-name="sight.name") {{ sight.name_en }}
      .col-12.col-md-4.explore-intro-sm
        .explore-content.pl-3.pb-3
          h1.explore-title {{ $t(`explore.title`) }}
          span.explore-text(v-html="$t(`explore.intro`)")
</template>

<script>
import ExploreDetail from "@/components/ExploreDetail.vue";
import Tooltip from "@/components/Tooltip.vue";
import preloader from "monoame-preloader";
import { TweenMax, TimelineMax, Sine, Linear } from "gsap";
import $ from "jquery";
export default {
  name: "Explore",
  components: {
    ExploreDetail,
    Tooltip
  },
  created() {
    let sight = this.$route.query.sight;
    if (sight) {
      let sightIsValid = false;
      // break forEach if found
      this.sights.find(s => {
        if (s.name === sight) {
          // sceneIndex = this.sights.indexOf(s);
          this.selectedSight = s;
          sightIsValid = true;
          return true;
        }
      });

      if (sightIsValid) {
        console.log(sight)
        let sightData = this.$t(`explore.sights.${sight}`);
        setTimeout(() => {
          let sightImg = document.querySelectorAll(`[data-sight-name='${sight}']`)[0];

          TweenMax.set(sightImg, {
            transformOrigin: "50% 50% 0%",
            y: 0
          });
          let scaleAni = new TimelineMax();

          scaleAni
            .to(sightImg, 1, {
              scale: 1.5,
              y: 0
            })
            .repeat(-1)
            .yoyo(1);
          let itemPos = sightImg.getBoundingClientRect();
          console.log(itemPos)
          // this.$refs.tooltip.setPosition({ x: itemPos.x, y: itemPos.y });
          this.$refs.tooltip.setPosition({ x: 30, y: 100 });
          // this.selectedItem = item;

          this.showTooltip = true;

          $(document)
            .add(".tooltip-closeIcon")
            .on("click", () => {
              scaleAni.kill();
              TweenMax.set(sightImg, {
                scale: 1,
                x: 0,
                y: 0
              });
            });
        }, 1500);
      } else {
        // do nothing
      }
    }
  },
  mounted() {
    $(".explore")
      .on("click", e => {
        if ($(e.target).is(".explore-map-item, .sight-name")) {
          this.clickSight(e);
          return;
        } else {
          this.showTooltip = false;
        }
      })
      .children(".st-tooltip, .explore-map")
      .click(function (e) {
        return false;
      });
  },
  data() {
    return {
      showTooltip: false,
      showDetail: false,
      sightMediaType: null,
      mousePos: { x: 0, y: 0 },
      selectedSight: {
        name: "101",
        name_zh: "",
        name_en: "",
        position: { bottom: 35, left: 70 },
        width: 13,
        maxWidth: 70,
        media: {
          pano: "101_pano.jpg",
          vr: null,
          video: null,
          panoDefault: {
            defaultLong: 2 * Math.PI * (-10 / 360),
            defaultLat: (Math.PI / 2) * (55 / 180),
            defaultZoomLvl: 30
          }
        }
      },
      sights: [
        {
          name: "beimen",
          name_zh: "北門",
          name_en: "North Gate (Beimen)",
          position: { bottom: 65, left: 55 },
          width: 15,
          maxWidth: 100,
          media: {
            pano: "beimen_pano-min.jpg",
            vr: null,
            video: null,
            panoDefault: {
              defaultLong: 2 * Math.PI * (-8 / 360),
              defaultLat: (Math.PI / 2) * (30 / 180),
              defaultZoomLvl: 10,
              sphereCorrection: {
                roll: 2 * Math.PI * (4 / 360)
              }
            }
          }
        },
        {
          name: "honglou",
          name_zh: "西門",
          name_en: "Ximen",
          position: { bottom: 50, left: 25 },
          width: 25,
          maxWidth: 150,
          panX: 3,
          media: {
            pano: "honglou_pano-min.jpg",
            vr:
              "https://3d.taipei/culture/indoor.html?m=mQy237SEGdu&t=%E8%A5%BF%E9%96%80%E7%B4%85%E6%A8%93",
            video: null,
            panoDefault: {
              defaultLong: 2 * Math.PI * (15 / 360),
              defaultLat: (Math.PI / 2) * (25 / 180),
              defaultZoomLvl: 10,
              sphereCorrection: {
                roll: 2 * Math.PI * (1 / 360)
              }
            }
          }
        },
        {
          name: "songyan",
          name_zh: "松山文創園區",
          name_en: "Songshan Cultural and Creative Park",
          position: { bottom: 63, left: 10 },
          width: 25,
          maxWidth: 150,
          panX: 2,
          media: {
            pano: null,
            vr: null,
            video: "https://www.youtube.com/watch?v=PAcQ8Ned_xc",
            panoDefault: null
          }
        },
        {
          name: "dadaocheng",
          name_zh: "大稻埕",
          name_en: "Dadaocheng",
          position: { bottom: 25, left: 50 },
          width: 25,
          maxWidth: 150,
          media: {
            pano: "dadaocheng_pano-min.jpg",
            vr:
              "https://3d.taipei/culture/indoor.html?m=uF21SMQfbWs&t=%E6%96%B0%E8%8A%B3%E6%98%A5%E8%8C%B6%E8%A1%8C",
            video: null,
            panoDefault: {
              defaultLong: 2 * Math.PI * (7 / 360),
              defaultLat: (Math.PI / 2) * (35 / 180),
              defaultZoomLvl: 1,
              sphereCorrection: {
                roll: 2 * Math.PI * (0 / 360)
              }
            }
          }
        },
        {
          name: "longshan",
          name_zh: "龍山寺",
          name_en: "Lungshan Temple",
          position: { bottom: 33, left: 30 },
          width: 27,
          maxWidth: 150,
          media: {
            pano: "longshan_pano-min.jpg",
            vr:
              "https://3d.taipei/culture/indoor.html?m=1rWZfF1uStR&t=%E5%89%9D%E7%9A%AE%E5%AF%AE%E6%AD%B7%E5%8F%B2%E8%A1%97%E5%8D%80",
            video: null,
            panoDefault: {
              defaultLong: 2 * Math.PI * (10 / 360),
              defaultLat: (Math.PI / 2) * (15 / 180),
              defaultZoomLvl: 1
            }
          }
        },
        {
          name: "moma",
          name_zh: "中山",
          name_en: "Zhongshan",
          position: { bottom: 45, left: 50 },
          width: 20,
          maxWidth: 150,
          media: {
            pano: "moma_pano-min.jpg",
            vr:
              "https://3d.taipei/culture/indoor.html?m=3SitzibMYo2&t=%E5%85%89%E9%BB%9E%E5%8F%B0%E5%8C%97(%E5%8F%B0%E5%8C%97%E4%B9%8B%E5%AE%B6)",
            video: null,
            panoDefault: {
              defaultLong: 2 * Math.PI * (14 / 360),
              defaultLat: (Math.PI / 2) * (22 / 180),
              defaultZoomLvl: 1,
              sphereCorrection: {
                roll: 2 * Math.PI * (0 / 360)
              }
            }
          }
        },
        {
          name: "101",
          name_zh: "台北101",
          name_en: "Taipei 101",
          position: { bottom: 35, left: 70 },
          width: 13,
          maxWidth: 70,
          media: {
            pano: "101_pano-min.jpg",
            vr: null,
            video: null,
            panoDefault: {
              defaultLong: 2 * Math.PI * (-10 / 360),
              defaultLat: (Math.PI / 2) * (55 / 180),
              defaultZoomLvl: 30
            }
          }
        }
      ]
    };
  },
  watch: {
    showDetail() {
      if (this.showDetail) {
        this.$store.dispatch("triggerLoading", 1000);
      }
      this.$store.commit("setShowingDetail", this.showDetail);
    }
  },
  methods: {
    getMousePos({ x, y }) {
      if (window.innerWidth > 800) {
        this.mousePos.x = x;
        this.mousePos.y = y;
      }
    },
    clickSight(e) {
      this.$refs.tooltip.setPosition({ x: e.pageX, y: e.pageY });
      let sightName = event.target.getAttribute("data-sight-name");
      let sight = this.sights.find(s => s.name === sightName);
      this.selectedSight = sight;
      this.showTooltip = true;
    },
    clickMedia(type) {
      if (type == "vr") {
        window.open(this.selectedSight.media.vr);
      } else {
        this.sightMediaType = type;
        this.showDetail = true;
      }
      this.showTooltip = false;
    },
    leaveImg() {
      if (window.innerWidth > 768) {
        this.showTooltip = false;
      }
    }
  },
  computed: {}
};
</script>

<style  lang="sass">
@import "@/assets/css/mixins.scss"

// .texture
  // min-height: size__site_min_height
.explore
  position: relative
  background-color: #FFFBF4
  width: 100%
  max-width: 100vw
  // height: 100%
  height: 100vh
  min-height: $size__site_min_height
  overflow: hidden
  background-image: url(/img/discover_grid.svg)
  background-position: 100% 0
  .container-fluid
    position: relative
  .explore-title
    pointer-events: none
    font-size: 3.5rem
    font-weight: 900
    margin-bottom: 20px
  .explore-intro-sm
    pointer-events: none
    display: none
  .explore-bg
    position: absolute
    // overflow: hidden
    left: 0
    top: 0
    width: 100%
    height: 100%
  .bg-text
    position: absolute
    font-weight: bold
    font-size: 320px
    font-size: min(25vw, 360px)
    color: transparent
    -webkit-text-stroke: 1px black
    transform: rotate(3deg)

  .bg-text-1
    left: -15vw
    top: -5vh
  .bg-text-2
    right: -10vw
    bottom: -5vh
  .explore-content
    display: flex
    height: fit-content
    flex-direction: column
    margin-top: calc(35vh + 10vw)
    margin-left: 3vw
    padding: 20px 10px
    border-radius: 10px
    align-items: flex-start
    line-height: 1.6
    background-color: rgba(255, 251, 244,0.9)
    color: #513b2c
  .explore-map
    background: url('../assets/images/explore_bkg_all.png')
    background-repeat: no-repeat
    background-position: center
    background-size: 100% auto
    width: 100%
    height: 100%
    max-width: 900px
    max-height: 90vh
    &:hover
      cursor: pointer
    .explore-map-item
      position: absolute
      transition-duration: 0.5s
      &:hover
        transform: scale(1.1)
        transition-duration: 0.5s
      img
        pointer-events: none
      img.sight-img
        width: 100%
      img.magnifier
        width: 35px
        position: absolute
        right: -15px
        top: 20%
        z-index: 0
      .sight-name
        position: absolute
        // pointer-events: none
        left: 50%
        top: 95%
        width: 200%
        white-space: break-spaces
        text-align: center
        transform: translateX(-50%)
        color: #fff
        text-shadow: 1px 0px 2px #333,2px 2px 2px #333
        letter-spacing: 1px
        // color: #132A38
        // text-shadow: 1px 0px 1px #ffffff, 1px 1px 1px #ffffff, 0px 1px 1px #ffffff
        font-size: 1.2rem
        font-weight: bold
.removeMinHeight
  min-height: unset

.explore-detail
  z-index: 87

@include for_breakpoint(mobile)
  .explore
    // overflow: initial
    max-height: 100vh
    height: 100vh
    overflow: hidden

    .explore-bg
      .bg-text.bg-text-1
        top: 2vh
      .bg-text.bg-text-2
        // display: none
        top: 40vh
    .explore-content
      margin-top: calc(8vh + 3vw)

    .explore-intro
      display: none
    .explore-intro-sm
      display: initial
      position: absolute
      bottom: 0
      padding-bottom: 5px
      .explore-content
        overflow: scroll
        background-color: transparent
        margin-left: 0vw
        .explore-title
          font-size: 2.2rem
          margin-bottom: 15px
          font-weight: 900
    .explore-map
      position: absolute
      height: 100vh
      max-height: none
      transform: translateY(-15vh)
      .explore-map-item
        transform: scale(0.8)
        &:hover
          transform: scale(0.9)
        .sight-name
          font-size: 1.2rem

@media screen and (orientation:landscape)
  .explore
    height: 100vh
    max-height: 100vh
    overflow: hidden
    .explore-map
      max-height: initial
</style>
